import Vue from "vue";
import Vuex from "vuex";
import Swal from "sweetalert2";

Vue.use(Vuex);

const carritoInicial = JSON.parse(sessionStorage.getItem("carrito") || "[]");

export default new Vuex.Store({
  state: {
    carrito: carritoInicial,
    notificacion: null,

    mostrarCarrito: false, // ← control de visibilidad
  },
  mutations: {
    mostrarNotificacion() {
      console.log("llegue");
      const ahora = new Date();
      const dia = ahora.getDay(); // 0=Domingo, 6=Sábado
      const hora = ahora.getHours();

      let mensaje = "";
      if (dia === 0 || (dia === 6 && hora >= 13)) {
        mensaje = `
      <b>¡Gracias por tu pedido!</b><br>
      <br>
      Te contactaremos en las próximas <b>24 horas</b> vía <span style="color:#25D366;">WhatsApp</span>.<br>
      <span style="font-size:12px;color:#888;">(Sábados después de la 1pm o domingos 24h)</span>
    `;
      } else {
        mensaje = `
      <b>¡Gracias por tu pedido!</b><br>
      <br>
      Te estaremos contactando en un lapso de <b>1 a 6 horas</b> vía <span style="color:#25D366;">WhatsApp</span>.<br>
      <span style="font-size:12px;color:#888;">(Horario hábil)</span>
    `;
      }

      return Swal.fire({
        html: mensaje,
        icon: "success",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#2c73d2", // azul suave
        background: "rgba(255,255,255,0.95)", // Blanco muy leve traslúcido
        color: "#1b365d", // texto azul oscuro
        backdrop: "rgba(60,60,60,0.13)", // Fondo traslúcido suave
        allowOutsideClick: false,
        allowEscapeKey: true,
        showClass: {
          popup: "swal2-show", // Usamos el default
          backdrop: "swal2-backdrop-show", // Default pero el color ya lo pones arriba
        },
        hideClass: {
          popup: "swal2-hide",
          backdrop: "swal2-backdrop-hide",
        },
      });
    },
    ocultarNotificacion(state) {
      state.notificacion = null;
    },
    agregarAlCarrito(state, producto) {
      // Busca si ya hay uno igual (id, imagenKey, talla, tipo)
      const existe = state.carrito.find(
        (p) =>
          p.id === producto.id &&
          p.imagenKey === producto.imagenKey &&
          p.talla === producto.talla &&
          p.tipo === producto.tipo &&
          p.codigo === producto.codigo &&
          (p.observacion || "") === (producto.observacion || "")
      );
      if (existe) {
        existe.cantidad += producto.cantidad;
      } else {
        state.carrito.push({ ...producto });
      }
      state.mostrarCarrito = true;
    },
    toggleCarrito(state, valor) {
      state.mostrarCarrito = valor;
    },
    vaciarCarrito(state) {
      state.carrito = [];
      state.mostrarCarrito = false;
      sessionStorage.setItem("carrito", "[]");
    },
    recalcularPreciosMayoreo(state, payload) {
      // Solo aplica si es mayorista
      if (!payload.esMayorista) return;
      // Suma todas las cantidades del mismo producto
      const cantidadTotal = state.carrito
        .filter((p) => p.id === payload.id)
        .reduce((acc, prod) => acc + prod.cantidad, 0);

      // Si hay 12 o más, cambia a precioMayoreo en todas las variantes de ese id
      if (cantidadTotal >= 12) {
        state.carrito.forEach((p) => {
          if (p.id === payload.id && payload.precioMayoreo) {
            const adicional = p.precioAdicional || 0;
            p.precio = Number(payload.precioMayoreo) + Number(adicional);
          }
        });
      } else {
        // Si baja de 12, volver al precioVenta normal
        state.carrito.forEach((p) => {
          if (p.id === payload.id && payload.precioVenta) {
            const adicional = p.precioAdicional || 0;
            p.precio = Number(payload.precioVenta) + Number(adicional);
          }
        });
      }
    },
    eliminarDelCarrito(state, idx) {
      const prod = state.carrito[idx]; // Guarda el producto a eliminar
      state.carrito.splice(idx, 1); // Elimínalo
      console.log(prod);
    },
  },
  getters: {
    totalCarrito(state) {
      return state.carrito.reduce(
        (acc, prod) => acc + prod.precio * prod.cantidad,
        0
      );
    },
    productosCarrito(state) {
      return state.carrito;
    },
    mostrarCarrito(state) {
      return state.mostrarCarrito;
    },
  },
  plugins: [
    (store) => {
      store.subscribe((mutation, state) => {
        sessionStorage.setItem("carrito", JSON.stringify(state.carrito));
      });
    },
  ],
});
